import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('No matches for'),
  instruction: i18nMark('Try removing or editing some of your criteria to expand the search or review another favorite.'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/NoFavoritesPanel/messages.js